import { useEffect } from 'react';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import {
    dispatchTrackingEvent,
    MAIN_MENU_CLICK,
    PROVIDER_ACQUISITION_HEADER_CLICK,
    PROVIDER_ACQUISITION_MENU_CLICK,
    MAIN_MENU_OPEN,
    MAIN_MENU_LINK_SELECTED,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';

function GlobalPageEvents() {
    useEffect(() => {
        if (IS_FRAME_SERVICE) {
            return undefined;
        }
        // Kombinirani tracking za desktop i mobile view.
        const elementIdToEventMappings = [
            ['mainMenuButton', MAIN_MENU_CLICK],
            ['headerBecomeOurProvider', PROVIDER_ACQUISITION_HEADER_CLICK],
            ['mobileMainMenuBecomeOurProvider', PROVIDER_ACQUISITION_MENU_CLICK],
            ['mainMenuButton', MAIN_MENU_OPEN],
        ];
        const listeners = [];
        elementIdToEventMappings.forEach(([id, eventName]) => {
            const element = document.getElementById(id);
            if (element) {
                const handler = () => {
                    dispatchTrackingEvent(eventName);
                };
                element.addEventListener('click', handler);
                listeners.push([element, handler]);
            }
        });

        // Tracking za otvaranje "main menu-a" na mobilnom view-u.
        const mainMenu = document.querySelector('#mainMenu');
        const handleMainMenuItemClick = (event) => {
            const menuLink = event.target.closest('a.nav-mob__item');
            if (!menuLink) return;
            dispatchTrackingEvent(MAIN_MENU_LINK_SELECTED, {
                link: menuLink.href,
            });
        };
        mainMenu?.addEventListener('click', handleMainMenuItemClick);

        // Tracking za otvaranje "main menu-a" na desktop view-u.
        const middleNav = document.querySelector('.middle-nav__list');
        const handleLinkClick = (event) => {
            const link = event.target.closest('a[href]');
            if (!link) return;
            dispatchTrackingEvent(MAIN_MENU_LINK_SELECTED, {
                link: link.href,
            });
        };
        const observers = middleNav
            ? [...middleNav.querySelectorAll('.nav-dropdown')].map((dropdown) => {
                const observer = new MutationObserver(() => {
                    if (!dropdown.classList.contains('d-none')) {
                        dispatchTrackingEvent(MAIN_MENU_OPEN);
                    }
                });
                observer.observe(dropdown, {
                    attributes: true,
                    attributeFilter: ['class'],
                });

                return observer;
            })
            : [];
        middleNav?.addEventListener('click', handleLinkClick);
        middleNav?.addEventListener('auxclick', handleLinkClick);

        return () => {
            listeners.forEach(([element, handler]) => {
                element.removeEventListener('click', handler);
            });
            mainMenu?.removeEventListener('click', handleMainMenuItemClick);
            observers.forEach((observer) => {
                observer.disconnect();
            });
            middleNav?.removeEventListener('click', handleLinkClick);
            middleNav?.removeEventListener('auxclick', handleLinkClick);
        };
    }, []);

    return null;
}

export default GlobalPageEvents;
